import { Button, CircularProgress, Typography } from '@mui/material';
import ControlModeAuthority from '@src/components/Home/Config/Stacks/ControlModesAuthority';
import { useState } from 'react';
import StackView from './StackView';
import useGetDefaultStack from '@hooks/api/queries/modes/useGetDefaultStack';
import { stacksViewSx } from '@components/_shared/sxStyles/Config/stacks';
import './Stacks.scss';
import StackModal from './StackModal';
import EditIcon from '@mui/icons-material/Edit';
import { isSuperAdmin } from '@src/services/auth';
import { UserRole } from '@src/services/auth/roles';
import storeConnector from '@store/storeConnector';

interface HMIDefaultProps {
  role: UserRole;
}

function HMIDefault({ role }: HMIDefaultProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const { data: defaultStack, isFetching, isRefetching } = useGetDefaultStack();

  const handleEditClick = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  if (isFetching || isRefetching) {
    return <CircularProgress />;
  }

  return (
    <main className='stacks__main'>
      <ControlModeAuthority />
      <section className='stacks__wrapper'>
        {defaultStack ? (
          <>
            {isSuperAdmin(role) && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginBottom: '16px',
                }}
              >
                <Button
                  variant='contained'
                  color='primary'
                  startIcon={<EditIcon />}
                  onClick={handleEditClick}
                >
                  Edit Default Stack
                </Button>
              </div>
            )}
            <StackView stack={defaultStack} isDefault={true} />

            <StackModal
              stackId={defaultStack.id}
              open={modalOpen}
              onClose={handleModalClose}
              isDefault={true}
            />
          </>
        ) : (
          <Typography sx={stacksViewSx.view.titles.noModes}>
            No Control Mode Templates Found
          </Typography>
        )}
      </section>
    </main>
  );
}

export default storeConnector(HMIDefault, {
  user: ['role'],
});
